export default {
  data() {
    return {
      showImg: false,
      variant: null,
      price: 0,
      currentBulkPrice: null,
      currentBulkPrices: [],
    };
  },
  computed: {
    product() {
      return this.myOrder.product;
    },
    item() {
      return this.myOrder.productItem;
    },
    variants() {
      return this.item.variants;
    },
    minVariant() {
      return this._.minBy(this.item.variants, 'price');
    },
  },
  watch: {
    variant(variant) {
      if (variant && variant.pricelist_product_variants) {
        const firstPricelistProducts = this._.first(variant.pricelist_product_variants);

        if (firstPricelistProducts) {
          this.currentBulkPrices = firstPricelistProducts.bulk_prices;

          const firstBulkPrice = this._.first(this.currentBulkPrices);

          this.price = firstBulkPrice
              ? firstBulkPrice.price_gross : variant.price;
        }
      } else {
        this.price = variant.price;
      }
    },
  },
  methods: {
    selectProduct() {
      this.$store.dispatch('ADD_PREV_ORDER_STEP', this.orderStep);

      /*this.$store.dispatch('SET_BULK_PRICE', this.currentBulkPrice);
      this.$store.dispatch('SET_PRODUCT_ITEM', this.myOrder.productItem);
      this.$store.dispatch('SET_PRODUCT_VARIANT_ID', this.variant.id);
      this.$store.dispatch('SET_PRICELIST_PRODUCT_ID',
          this._.first(this.variant.pricelist_product_variants).id);
      this.$store.dispatch('SET_ORDER_STEP', `${this._.first(
          this.orderStep.split('-'))}-${this.product.slug}-more-photos`);*/

      if (this.item.variants.length === 1) {
        const variant = this._.first(this.item.variants);

        this.item.price = parseFloat(variant.price);

        this.$store.dispatch('SET_BULK_PRICE', null);
        this.$store.dispatch('SET_PRODUCT_ITEM', this.item);
        this.$store.dispatch('SET_PRODUCT_VARIANT_ID', variant.id);

        if (variant.pricelist_product_variants.length > 0) {
          this.$store.dispatch('SET_PRICELIST_PRODUCT_ID',
              this._.first(variant.pricelist_product_variants).id);
        }
      }

      const step = `${this._.first(
          this.orderStep.split('-'))}-${this.product.slug}-${this.item.variants.length > 1
          ? 'variants' : 'more-photos'}`;

      this.$store.dispatch('SET_ORDER_STEP', step);
    },
  },
  created() {
    if (this.variants) {
      this.variant = this._.first(this.variants);
    }
  },
};
